<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs v-model="currentGroupId" @click_breadCrumbs="selectedGroupChange" />
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col>
        <v-card outlined>
          <v-card-text>
            <v-row class="">
              <v-col>
                <v-tabs value="tab-1" v-model="tab">
                  <v-tab href="#tab-1" class="mx-2 rounded-t" @change="tab1Active">{{ $t('byCompany') }}</v-tab>
                  <v-tab href="#tab-2" class="mx-2 rounded-t" @change="tab2Active">{{ $t('byMachine') }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item value="tab-1">
                    <HomeAdminTab1 v-model="currentGroupId" @update_child="selectedGroupChange" />
                  </v-tab-item>
                  <v-tab-item value="tab-2">
                    <HomeAdminTab2 v-model="currentGroupIdTab2" />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import HomeAdminTab1 from '@/views/HomeAdminTab1.vue';
  import HomeAdminTab2 from '@/views/HomeAdminTab2.vue';
  import BreadCrumbs from '@/components/BreadCrumbs.vue';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Table',
    components: {
      HomeAdminTab1,
      HomeAdminTab2,
      BreadCrumbs,
    },
    data: () => ({
      tab: '',
      allGropus: [],
      currentGroupId: null,
      currentGroupIdTab2: null,
    }),
    filters: {},
    computed: {
      isTab1Active() {
        return this.tab === 'tab-1';
      },
      isTab2Active() {
        return this.tab === 'tab-2';
      },
    },
    created() {
      const groupId = this.$route.params.device_group_id;
      if (groupId) {
        this.currentGroupId = groupId;
      }
    },
    methods: {
      async selectedGroupChange(group) {
        console.log('グループ変更');
        this.currentGroupId = group.device_group_id;
        if (this.isTab2Active) {
          this.currentGroupIdTab2 = this.currentGroupId;
        }
      },
      tab1Active() {},
      tab2Active() {
        // 号機別がアクティブの場合のみ更新
        this.currentGroupIdTab2 = this.currentGroupId;
      },
    },
  };
</script>
<style scoped>
  /** タブ非活性時 */
  .tabDisabled {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
  }
</style>
